// extracted by mini-css-extract-plugin
module.exports = {"order-list-skeleton":"ordersSkeletons_order-list-skeleton__39QPO","mobile-only":"ordersSkeletons_mobile-only__fAHlo"};